import { useCallback, useState } from "react";
import { useScreenSize } from "./media-query";

export function useMenuPatch() {
	const {
		isSmallVertical,
		isSmallHorizontal,
		isMediumVertical,
		isMediumHorizontal,
	} = useScreenSize();
	const [enabled, setEnabled] = useState(
		isSmallVertical ||
			isSmallHorizontal ||
			isMediumVertical ||
			isMediumHorizontal,
	);
	const onMenuReady = useCallback(() => {
		if (!enabled) {
			return;
		}

		setTimeout(() => setEnabled(false));
	}, [enabled]);

	return [enabled ? "pre-init-blink-fix" : "", onMenuReady] as [
		string,
		() => void,
	];
}
